import React from 'react';
import { Heart } from 'lucide-react';
import './Footer.css';

function Footer() {
  const handleScroll = (targetId) => {
    const element = document.getElementById(targetId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const currentYear = new Date().getFullYear();

  return (
    <footer className="main-footer">
      <div className="footer-container">
        
        {/* Left Column: Branding & Credentials Summary */}
        <div className="footer-brand">
          <span className="footer-logo">Confident Expression, LLC</span>
          <p className="footer-creds">
            Alisa Zuka, M.A., M.S., CCC-SLP, CSLD-I<br />
            Speech-Language Pathologist
          </p>
          {/* <p className="footer-tagline">
            Fostering clear, confident communication virtually across MA &amp; NH.
          </p> */}
        </div>

        {/* Right Column: Quick In-Page Links */}
        {/* <div className="footer-links-group">
          <h3>Navigation</h3>
          <ul className="footer-nav">
            <li><button onClick={() => handleScroll('home')}>About Alisa</button></li>
            <li><button onClick={() => handleScroll('testimonials')}>Services &amp; Training</button></li>
            <li><button onClick={() => handleScroll('contact')}>Get In Touch</button></li>
          </ul>
        </div> */}

      </div>

      {/* Bottom Legal Stripe */}
      <div className="footer-bottom">
        <p>
          &copy; {currentYear} Confident Expression, LLC. All rights reserved.
        </p>
        {/* <p className="footer-credit">
          Built with <Heart size={12} className="heart-icon" /> for Alisa
        </p> */}
      </div>
    </footer>
  );
}

export default Footer;